
type Props = {
  pageSize: number;
  setPageSize: Function;
};

const ShowRows = ({ pageSize, setPageSize }: Props) => {
  return (
    <div className="mx-4 w-[85px]">
      <select 
        value={pageSize} 
        className="tqs-input-xs px-2 py-1"
        onChange={(e) => setPageSize(Number(e.target.value))}>
        {[10, 25, 50, 75, 100, 150, 200].map((pageSize) => (
          <option key={pageSize} value={pageSize}>
            Show {pageSize}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ShowRows;